import { mockOlympusClient as e } from "./mock.olympus.client.js";
import { createOlympusGameApi as t } from "./olympus-game-api.js";
import { createOlympusClient as n } from "@magnopus-opensource/connected-spaces-platform-web-api";
import { featureFlagStore as r } from "@magnopus/env";
//#region src/lib/services/olympus/olympus.service.ts
var i = "olympusReady", a = class {
	_client;
	_olyCore;
	_olympusGameApi;
	get client() {
		if (process.env.STORYBOOK) return e;
		if (!this._client) throw Error("OKO client must be initialised first");
		return this._client;
	}
	get olympusCore() {
		return this._olyCore;
	}
	getAccessToken = () => {
		if (this._client) return this.client.auth.getAccessToken() || void 0;
	};
	_accessTokenListeners = /* @__PURE__ */ new Set();
	registerRememberMe(e) {
		this.client.auth.rememberMe((t) => {
			e(t), this.notifyAccessTokenChanged();
		});
	}
	logout = async () => {
		try {
			await this.client.auth.logout();
		} finally {
			this.notifyAccessTokenChanged();
		}
	};
	notifyAccessTokenChanged = () => {
		queueMicrotask(() => {
			this._accessTokenListeners.forEach((e) => e());
		});
	};
	subscribeToAccessToken = (e) => (this._accessTokenListeners.add(e), () => {
		this._accessTokenListeners.delete(e);
	});
	restoreClient(e) {
		this._client = e;
	}
	async initializeClient({ chsBaseUrl: e, tenant: t, redirectUrls: a, maintenanceUrl: o, sessionInfo: s }) {
		if (this._client) return;
		let c = await n({
			endpoint: e,
			tenant: t,
			sessionInfo: s,
			redirectUrls: a,
			maintenanceUrl: o
		});
		this._client = c;
		let l = new Event(i);
		window.dispatchEvent(l), r.subscribe((e, t) => {
			e.authFeatureFlags.get("parallel_graphql_queries") !== t.authFeatureFlags.get("parallel_graphql_queries") && c.graphql.enableParallelQueries(!!e.authFeatureFlags.get("parallel_graphql_queries"));
		});
	}
	async initializeOlympusCore({ canvas: e, loadAssetUrl: n, options: r, spaceId: i, currentSpaceDetails: a, currentSpaceQuotaFeatures: o, componentEvents: s, notifications: c, createOlympusCore: l }) {
		if (this._olyCore && console.warn("Olympus Core is already initialized. Creating a new instance"), !this._client) throw Error("Olympus client must be initialized before Olympus Core");
		return this._olyCore = await l(e, this.client.internalEvents, {
			getAvatar: (e) => this.client.users.getAvatar(e),
			getAsset: this.client.assets.getAsset,
			getMaterial: this.client.materials.get,
			getUser: this.client.users.get,
			getSpace: this.client.spaces.get,
			getSpaceThumbnail: this.client.spaces.getSpaceThumbnail,
			getCurrentSpace: () => a,
			getCurrentSpaceQuotaFeatures: () => o,
			invokeExternalServiceOperation: this.client.externalServiceProxy.invokeOperation,
			componentEvents: s
		}, n, r, i, c), this._olympusGameApi = t(this.client), this._olyCore;
	}
	startSession(e, t, n, r) {
		if (!this._olyCore) throw Error("Olympus Core API is not initialized");
		if (!this._olympusGameApi) throw Error("Olympus Game API is not initialized");
		return this._olympusGameApi.startSession(this._olyCore, e, t, n, r);
	}
	spawnPlayer(e, t) {
		if (!this._olympusGameApi) throw Error("Olympus Game API is not initialized");
		return this._olympusGameApi.spawnPlayer(e, t);
	}
	startOfflinePreviewSession(e, t, n) {
		if (!this._olyCore) throw Error("Olympus Core API is not initialized");
		if (!this._olympusGameApi) throw Error("Olympus Game API is not initialized");
		return this._olympusGameApi.startOfflinePreviewSession(this._olyCore, e, t, n);
	}
	spawnPreviewCamera(e) {
		if (!this._olympusGameApi) throw Error("Olympus Game API is not initialized");
		return this._olympusGameApi.spawnPreviewCamera(e);
	}
	endSession(e) {
		if (!this._olympusGameApi) return console.warn("endSession:Olympus Game API is not initialized or session has already been ended"), !0;
		let t = this._olympusGameApi.endSession(e);
		return this._olyCore = void 0, this._olympusGameApi = void 0, t;
	}
	set currentUserId(e) {
		o = e;
	}
}, o = "";
function s() {
	return o;
}
var c = new a();
//#endregion
export { s as getCurrentUserID, c as olympusService };
